module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vue-chuckadmin"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(_vm.isLogged) ? _c('div', [_c('app-header', {
    attrs: {
      "loggedUser": _vm.loggedUser
    },
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "cc-inside"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "ion-android-home"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _c('li', [_c('h3', [_c('i', {
    staticClass: "ion-person-stalker"
  }), _vm._v("\n                                Persons\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admins'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("Administrators")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("Users list")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'user-add'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("Add a user")])])], 1)])], 1)])]), _vm._v(" "), _c('li', [_c('h3', [_c('i', {
    staticClass: "ion-android-folder"
  }), _vm._v("\n                                Pages\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cms'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("CMS")])])], 1)])])])])]), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "duration": {
        enter: 600,
        leave: 30
      },
      "name": "fade",
      "mode": "out-in",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('router-view')], 1)], 1)], 1) : _c('div', {
    staticClass: "login-form"
  }, [_c('login-form', {
    on: {
      "login": _vm.login
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8064af68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/App.vue
// module id = 231
// module chunks = 0